import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Stack, TextField } from '@mui/material'
import MediaUploadPreview from '@professocial/professocialFormComponents/FormComponents/MediaUploadPreview'

interface IProps {
  posting: any
  deleteImage?: () => void
}

const LinkPostPreview: React.FC<IProps> = ({ posting, deleteImage }) => {
  const { t } = useTranslation()
  return (
    <Stack direction='row' spacing={4} sx={{ width: '100%' }}>
      <Box style={{ display: 'flex', alignItems: 'center' }}>
        <MediaUploadPreview
          view='column'
          deleteMediaFile={deleteImage}
          src={posting.content.link && posting.content.link.imageUrl}/>
      </Box>
      <Stack spacing={2} sx={{ width: '100%' }}>
        <TextField label={t('common:title')} variant='outlined' defaultValue={posting.content.link && posting.content.link.caption} size='small' fullWidth disabled />
        <TextField label={t('topics:description')} variant='outlined' defaultValue={posting.content.link && posting.content.link.description} size='small' fullWidth disabled />
        <TextField label={t('common:url')} variant='outlined' defaultValue={posting.content.link && posting.content.link.url} size='small' fullWidth disabled />
      </Stack>
    </Stack>
  )
}

export default LinkPostPreview
